// src/services/api.js
import { fetchAuthSession, getCurrentUser } from '@aws-amplify/auth';

const API_URL = process.env.REACT_APP_API_URL;

// Shared response handler
async function handleResponse(res) {
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || res.statusText);
  }
  return res.json();
}

async function getIdToken() {
  // 1) Try fetchAuthSession()
  try {
    const session = await fetchAuthSession({
      provider: 'userPoolTokens',
      forceRefresh: false
    });
    // console.log('[api] fetchAuthSession.tokens =', session.tokens);

    // Use toString() to get the JWT
    const token = session.tokens?.idToken?.toString?.();
    if (token) {
      // console.log('[api] Using token from fetchAuthSession');
      return token;
    }
  } catch (err) {
    console.warn('[api] fetchAuthSession threw:', err);
  }

  // 2) Fallback: getCurrentUser()
  try {
    const user = await getCurrentUser();
    console.log('[api] getCurrentUser.session =', user.signInUserSession);
    const token = user.signInUserSession?.idToken?.toString?.();
    if (token) {
      console.log('[api] Using token from getCurrentUser');
      return token;
    }
  } catch (err) {
    console.warn('[api] getCurrentUser threw:', err);
  }

  throw new Error('No ID token available; ensure returnSession:true and user is signed in');
}

// src/services/api.js

export async function listFiles(sub = '') {
  const token = await getIdToken();
  let url = `${API_URL}/list`;
  if (sub) url += `?sub=${encodeURIComponent(sub)}`;
  const res = await fetch(url, {
    method: 'GET',
    headers: { Authorization: token }
  });
  return handleResponse(res);
}


export async function getUploadUrl(path = '', filename) {
  const token = await getIdToken();
  const res = await fetch(`${API_URL}/upload`, {
    method: 'POST',
    headers: {
      Authorization: token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ path, filename })
  });
  return handleResponse(res);
}

export async function getDownloadUrl(key) {
  const token = await getIdToken();
  const res = await fetch(
    `${API_URL}/download?key=${encodeURIComponent(key)}`, {
      method: 'GET',
      headers: { Authorization: token }
    }
  );
  return handleResponse(res);
}

export async function createFolder(path = '', folderName) {
  const token = await getIdToken();
  const res = await fetch(`${API_URL}/folder`, {
    method: 'POST',
    headers: {
      Authorization: token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ path, folderName })
  });
  return handleResponse(res);
}

export async function deleteKey(key) {
  const token = await getIdToken();
  const res = await fetch(`${API_URL}/delete`, {
    method: 'DELETE',
    headers: {
      Authorization: token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ key })
  });
  return handleResponse(res);
}
